import { cn } from "@/src/utils/shadcn";
import Image from "next/image";
export interface CertificateCardModelProps {
  img: string;
}

export function CertificateCardModel({ img }: CertificateCardModelProps) {
  return (
    <div
      className={cn([
        // General
        "group/service bg-white text-accent-900 border transition-transform duration-350 dark:text-white  dark:shadow-none",

        // Layout
        "relative z-1 block h-full overflow-hidden rounded-5 p-6 md:p-4",

        // Fixed height for the card
        "h-[100px] md:h-[120px]",

        //Hover
        "hover:border-primary hover:bg-[rgba(82,128,193,.1)]",
      ])}
    >
      <div className="flex justify-center items-center h-full">
        <img
          style={{ objectFit: "cover" }}
          src={img}
          alt="iso"
          className="max-w-full max-h-full object-contain scale-100 h-auto"
        />
      </div>
    </div>
  );
}
